import { Controller } from "stimulus";

class SponsorRowDisclaimerController extends Controller {
  connect() {
  }

  showDisclaimer() {
    EventManager.emit('sponsor-row-show-disclaimer', {
      disclaimerLogo: this.element.dataset.disclaimerLogo,
      disclaimerTitle: this.element.dataset.disclaimerTitle,
      disclaimerText: this.element.dataset.disclaimerText
    });
  }

  mouseEnterDisclaimer() {
    var sponsoredRow = this;

    this.disclaimerTimeout = setTimeout(function() {
      sponsoredRow.showDisclaimer();
    }, 500);
  }

  mouseLeaveDisclaimer() {
    clearTimeout(this.disclaimerTimeout);
  }
}

export default SponsorRowDisclaimerController;
